import React, { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button } from '@mui/material';

const MappingRules = () => {
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [rows, setRows] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedRowData, setSelectedRowData] = useState(null); 
  const [isEditModalOpen, setIsEditModalOpen] = useState(false); 
  const [formData, setFormData] = useState({ procedureFrom: '', designMode: '', materialClass: '', procedureTo: '' });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('https://hms.backend.hiragroupcloud.com/api/mappingRules');
        if (!response.ok) {
          throw new Error('Failed to fetch data');
        }
        const data = await response.json();
        setRows(data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  const handleEdit = (id) => {

    const rowData = rows.find(row => row._id === id);
    if (!rowData) {
        console.error('No row data found for ID:', id);

        return;
    }

    setSelectedRowData(rowData);
    setFormData(rowData); // Populate the form data with the selected row's data
    setIsEditModalOpen(true);
};

  const handleModalClose = () => {
    setIsEditModalOpen(false);
    setSelectedRowData(null); 
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSaveChanges = async () => {
    if (!selectedRowData) {
      console.error("Selected row data is missing");
      return;
    }

    try {
      const response = await axios.put(`https://hms.backend.hiragroupcloud.com/api/updateMappingRules/${selectedRowData._id}/`, formData);
      if (response.data.success) {
        const updatedRows = rows.map(row => 
          row._id === selectedRowData._id ? { ...row, ...formData } : row
        );
        setRows(updatedRows);
        handleModalClose();
      } else {
        console.error("Failed to save changes:", response.data.message);
      }
    } catch (error) {
      console.error('There was an error saving the data:', error);
    }
  };

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(`https://hms.backend.hiragroupcloud.com/api/deleteMappingRules/${id}`);
      if (response.data.success) {
        setRows(rows.filter(row => row.id !== id));
        setSelectedRowId(null);
      } else {
        console.error("Failed to delete account:", response.data.message);
      }
    } catch (error) {
      console.error('There was an error deleting the account:', error);
    }
  };

  const handleRowClick = (id) => {
    setSelectedRowId(id === selectedRowId ? null : id);
  };

  const filteredRows = rows.filter(row =>
    Object.values(row).some(value =>
      value.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const columns = [
    { field: 'procedureFrom', headerName: 'Procedure', width: 150 },
    { field: 'designMode', headerName: 'Design Mode', width: 150, align: 'center', headerAlign: 'center' },
    { field: 'materialClass', headerName: 'Material Class', width: 200, align: 'center', headerAlign: 'center' },
    { field: 'procedureTo', headerName: 'To Labnet Procedure', width: 150, align: 'center', headerAlign: 'center' },
  ];

  return (
    <>
      <h2 className="title" >Mapping Rules</h2>
      <div style={{background:'#f4f4f4',padding: '10px',width:"1560px",margin:'0 auto'}}>
      
      <div className="search">
        <div className="row align-items-center">
            <div className="col-md-6 d-flex justify-content-start">
              <input
                type="text"
                id="searchInput"
                className="form-control"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          <div className="col-md-6 d-flex justify-content-end">
            <Link to="/AddImportMap" className="btn btn-primary" style={{backgroundColor:'#004aad',borderColor:'#004aad'}}>Add</Link>
          </div>
        </div>
      </div>

      <div style={{ height: 350, width: '100%', position: 'relative', marginTop: '2%',  }}>
        <DataGrid
          rows={filteredRows}
          columns={columns}
          pageSize={5}
          onRowClick={(row) => handleRowClick(row.id)}
          getRowId={(row) => row._id}
          components={{
            Toolbar: () => null,
          }}
          sx={{
            '& .MuiDataGrid-columnHeaderTitle': {
              fontWeight: 'bold',
            },
            '& .MuiDataGrid-cell:focus': {
              outline: 'none',
            },
            '& .MuiDataGrid-cell:focus-within': {
              outline: 'none',
            },
          }}
        />
        {selectedRowId !== null && (
          <div
            style={{
              position: 'absolute',
              top: rows.findIndex(row => row._id === selectedRowId) * 52 + 48,
              right: '10px',
              display: 'flex',
              marginTop: '15px'
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleEdit(selectedRowId)}
              sx={{ marginRight: 1 }}
            >
              Edit
            </Button>
            <Button
              variant="contained"
              sx={{ backgroundColor: 'red', '&:hover': { backgroundColor: '#c62828' } }}
              onClick={() => handleDelete(selectedRowId)}
            >
              Delete
            </Button>
          </div>
        )}
      </div>
      
      </div>

      <Dialog open={isEditModalOpen} onClose={handleModalClose}>
    <DialogTitle>Edit Mapping Rule</DialogTitle>
    <DialogContent>
        <TextField
            autoFocus
            margin="dense"
            label="Procedure From"
            name="procedureFrom"
            fullWidth
            value={formData?.procedureFrom || ''} // Use optional chaining
            onChange={handleChange}
        />
        <TextField
            margin="dense"
            label="Design Mode"
            name="designMode"
            fullWidth
            value={formData?.designMode || ''} // Use optional chaining
            onChange={handleChange}
        />
        <TextField
            margin="dense"
            label="Material Class"
            name="materialClass"
            fullWidth
            value={formData?.materialClass || ''} // Use optional chaining
            onChange={handleChange}
        />
        <TextField
            margin="dense"
            label="To Labnet Procedure"
            name="procedureTo"
            fullWidth
            value={formData?.procedureTo || ''} // Use optional chaining
            onChange={handleChange}
        />
    </DialogContent>
    <DialogActions>
        <Button onClick={handleModalClose} color="primary">
            Cancel
        </Button>
        <Button onClick={handleSaveChanges} color="primary">
            Save Changes
        </Button>
    </DialogActions>
</Dialog>
    </>
  );
};

export default MappingRules;
